var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 41.1484H10.7812C4.83647 41.1484 0 36.312 0 30.3672V15.6328C0 9.68803 4.83647 4.85156 10.7812 4.85156H35.2188C41.1635 4.85156 46 9.68803 46 15.6328V30.3672C46 36.312 41.1635 41.1484 35.2188 41.1484ZM10.7812 8.44531C6.81806 8.44531 3.59375 11.6696 3.59375 15.6328V30.3672C3.59375 34.3304 6.81806 37.5547 10.7812 37.5547H35.2188C39.1819 37.5547 42.4062 34.3304 42.4062 30.3672V15.6328C42.4062 11.6696 39.1819 8.44531 35.2188 8.44531H10.7812ZM29.5843 26.181L38.4658 19.3967C39.2544 18.7943 39.4054 17.6667 38.803 16.878C38.2005 16.0894 37.0729 15.9385 36.2843 16.5409L27.4039 23.3243C24.8396 25.2801 21.2586 25.2816 18.6926 23.3293L10.0873 16.64C9.30377 16.0308 8.17479 16.1723 7.56583 16.9559C6.95678 17.7394 7.0982 18.8683 7.88172 19.4773L16.4937 26.1718C16.498 26.1752 16.5024 26.1785 16.5068 26.1818C18.4316 27.6499 20.7379 28.3838 23.0447 28.3838C25.3516 28.3838 27.6588 27.6494 29.5843 26.181Z",
    fill: "#012913"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.371345f97d4aeccd13084c11328aefad.svg";
export { ForwardRef as ReactComponent };